import React, {createContext, memo, useState} from "react";

//Bootstrap
import { Row, Col } from "react-bootstrap";

//Data
import Data from "./data.json";

//Common
import Header from "./components/header";

//Components
import Challenges from "./components/challenges";
import Steps from "./components/steps";
import Products from "./components/products";
import Solutions from "./components/solutions";

export const AppContext = createContext();

function AppProvider({ children }) {
  const [data, setData] = useState({
    challenges: Data.challenges,
    steps: Data.steps,
    products: Data.products,
    solutions: Data.solutions,
    noSolutionsFound: false,
    stepsTitle: 'Select mAb Workflow step'
  });

  window.addEventListener('message', function(e) {
    const originDomain = e.data;

    const newSolutions = data.solutions.map((solution) => {
      return {
        ...solution,
        link: solution.link.includes(originDomain) ? solution.link: originDomain + solution.link
      }
    });
    setData({
      ...data,
      solutions: newSolutions
    });
  });

  return (
      <AppContext.Provider value={{ data, setData }}>
        {children}
      </AppContext.Provider>
  );
}

const HomeContent = memo(() => {
  return (
      <div className="pharma-workflow-configurator">
        <div className="main-container p-4">
          <Row className="h-100">
            <Col md={12} lg={6} xl={5} xxl={5} className="h-100">
              <div className="tile tile-left px-3 pt-4 bg-white h-100">
                <Header />
                <Challenges />
                <Steps />
                <Products  />
              </div>
            </Col>
            <Col md={12} lg={6} xl={7} xxl={7} className="h-100">
              <div className="tile tile-right bg-opacity-80 px-3 h-100">
                <Solutions />
              </div>
            </Col>
          </Row>
        </div>
      </div>
  );
});

export default function App() {
  return (
      <AppProvider>
        <HomeContent />
      </AppProvider>
  );
}